module.exports = __webpack_public_path__ + "media/src/application/media/v2-img-4-29ba97bc01ade8c659477062f087edcf.png";